import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { ReactSVG } from 'react-svg';
import { Button, RadioButton } from 'grommet';
import DropButton from './DropButton';

const StyledSelectMenu = styled(Button)`
  padding: 0.5rem;
  border-radius: var(--app-radius);

  &:hover {
    color: ${({ highlightText }) => highlightText};
  }
`;

const StyledFlexibleDrop = styled((props) => <DropButton {...props} />)`
  border-radius: ${({ customRadius }) => customRadius || 'var(--app-radius)'};

  > button {
    background: ${({ bgColor }) => bgColor ?? 'var(--page-input-bg)'};
    font-size: 0.8rem;
    padding: ${({ customPad }) => customPad || '0.3rem'};
    border-radius: ${({ customRadius }) => customRadius || 'var(--app-radius)'};
    border: ${({ noBorder }) => !noBorder && '1px solid var(--page-input-border)'};
    border-color: ${({ isOpen, highlight }) => (isOpen ? highlight : 'var(--page-input-border)')};
    min-width: ${({ width }) => width};
    height: ${({ height }) => height};

    &:focus {
      border-color: ${({ highlight }) => highlight};
    }

    > div {
      border-radius: ${({ customRadius }) => customRadius || 'var(--app-radius)'};
      width: 100%;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: center;
    }
  }
`;

const StyledSVG = styled(ReactSVG)`
  svg {
    height: ${({ height }) => height};
    width:${({ width }) => width};

    ${({ $fillColor }) => $fillColor && `
      fill: ${$fillColor};

      path, rect {
        fill: ${$fillColor};
      }
    `};

    &:hover {
      fill: ${({ $hoverColor }) => $hoverColor};

      path, rect {
        fill: ${({ $hoverColor }) => $hoverColor};
      }
    }
  }
`;

const StyledHoverButton = styled(Button)`
  border-radius: var(--app-radius);
  padding: 0.25rem 0.6rem;

  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
    
    span {
      color: ${({ hoverTextColor, textColor }) => (hoverTextColor ?? textColor)};
    }

    svg {
      fill: ${({ hoverTextColor, textColor }) => (hoverTextColor ?? textColor)};

      path {
        fill: ${({ hoverTextColor, textColor }) => (hoverTextColor ?? textColor)};
      }
    }
  }
`;

const StyledRadioButton = styled(RadioButton)`
  font-size: 1rem;

  label {
    font-weight: 600;
    color: ${({ color }) => color || 'inherit'};
  }

  + div {
    background: transparent;
    border-color: ${({ borderColor }) => borderColor};
    width: ${({ circleSize }) => circleSize || '24px'};
    height: ${({ circleSize }) => circleSize || '24px'};
  }

  &:checked + div {
    border-color: ${({ highlightColor }) => highlightColor};
  }

  &:checked + div > svg {
    fill: ${({ highlightColor }) => highlightColor};

    circle {
      fill: ${({ highlightColor }) => highlightColor};
    }
  }

  &:hover + div {
    border-color: ${({ highlightColor }) => highlightColor} !important;

    > svg {
      fill: ${({ highlightColor }) => highlightColor};
      circle {
        fill: ${({ highlightColor }) => highlightColor};
      }
    }
  }
`;

const StyledReactTooltip = styled(ReactTooltip)`
  font-family: inherit;
  border-radius: 4px;
  color: var(--button-primary-text) !important;
  background-color: ${({ bgColor }) => `${bgColor} !important`};
  padding: 0.3rem 0.5rem !important;
  z-index: 9999;
  opacity: 1 !important;
`;

const StyledSortButton = styled(Button)`
  background: ${({ buttonBg }) => buttonBg || 'var(--page-input-bg)'};
  border-radius: ${({ customRadius }) => customRadius || 'var(--app-radius)'};
  padding: ${({ customPad }) => customPad || '0.3rem'};
  height: var(--table-controls-height);
  min-width: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--page-input-border);
  border-right: none;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:hover, &:focus {
    border-color: var(--page-focus-highlight);
    outline: none;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: ${({ iconBoxSize }) => iconBoxSize || '1.25rem'};
    min-height: ${({ iconBoxSize }) => iconBoxSize || '1.25rem'};
    flex: 1 1 0%;
    width: 100%;
    height: 100%;

    > div { display: flex; }
  }
`;

export {
  StyledSelectMenu,
  StyledFlexibleDrop,
  StyledSVG,
  StyledSortButton,
  StyledRadioButton,
  StyledHoverButton,
  StyledReactTooltip,
};
